import React, { Component } from "react";
import ReactDOM from 'react-dom';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid'
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import FeatureCard from '../Components/Featurescards/index'
// import placeholder from '../img/placeholder.png'
import junaid from '../img/junaid.jpg'
import hamza from '../img/hamza (1).jpg'
import abdulla from '../img/abdullah.png'
// import albin from '../img/albin.jpg'
import ahmed from '../img/ahmed.jpg'
// import isaac from '../img/issac1.jpg'
import fazain from '../img/Faizan.png'
import ibrar from '../img/Abrar.png'
import Shabaz from '../img/shahbaz.png'
// import HereisgHassan from '../img/HereisgHassan.jpg'
import tahseen from '../img/Tehseen.png'
// import google from '../img/google.png'
import TeamCard from '../Components/TeamCard12/TeamCard'
import './home.css'



const Team = () => {
  return (
    <div className="bc---feature " id="Team" style={{backgroundColor: '#ffffff',color: 'black',display: 'block',borderBottom:'1px solid black'}}>
        <Container maxWidth="lg" className="py-5 my-5">
            <Grid
                container
                className=""
            >
                <Grid 
                    container 
                    direction="column"
                    justify="center"
                    alignItems="flex-start"
                    xs={12}
                    className="" style={{display: "block"}}
                >
                 {/* <h3 className="bc---section_subHeading">Meet the team</h3> */}
                 <h6 className="pcc---section-main-heading text-center" style={{fontSize: "29px"}}>TEAM</h6>
                
                </Grid>
                <Grid 
                    container 
                    direction="rows"
                    justify="center"
                    alignItems="flex-start"
                    xs={12}
                    className="pt-5"
                >
                <TeamCard 
                    image={ahmed}
                    name="Ahmed Khan Niazi"
                    designation="CEO"
                    // discription="I look forward to seeing pCATv3 become an even bigger success than its previous iteration. We've taken what we've learnt in the past and applied it to the current algorithm. Fingers crossed!"
                    facebook="@"
                    linkedin="https://www.linkedin.com/in/ahmed-hassan-khan-niazi-284105152/"
                    twitter="https://twitter.com/AhmedNi06855478"
                    github="@"
                    google="@"
                    github1="@"
                />
                <TeamCard 
                    image={tahseen}
                    name="Raja Muhammad Tehseen"
                    designation="CTO"
                    // discription="If you want the rainbow,you gotta put up with the rain."
                    facebook="@"
                    linkedin="https://www.linkedin.com/in/tehseen-raja-47a795106/"
                    twitter="@"
                    github="@"
                    google="@"
                    github1="@"
                />

                {/* <TeamCard 
                    image={junaid}
                    name="Junaid Khalid"
                    designation="CTO & Senior Developer"
                    discription="pCATv2 is something that I hold very dear. We're doing what we can to pass all audits and stringent tests to make sure this goes straight to the moon!"
                    facebook="@"
                    linkedin="https://linkedin.com/in/junaidkhalid22"
                    twitter="https://twitter.com/junaid9800"
                    github="https://githubcampus.expert/mkhalid1/"
                    // google={google}
                    github1="@"
                /> */}
                {/* <TeamCard 
                    image={tahseen}
                    name="Raja Muhammad Tehseen"
                    designation="CEO & COM"
                    discription="If you want the rainbow,you gotta put up with the rain."
                    facebook="@"
                    linkedin="https://www.linkedin.com/in/tehseen-raja-47a795106/"
                    twitter="@"
                    github="@"
                    google="@"
                    github1="@"
                />*/}
                
                
               

                <TeamCard 
                    image={fazain}
                    name="Faizan Azhar"
                    designation="Technical lead"
                    // discription="In the end, we regret only the chances we didn't take"
                    facebook="@"
                    linkedin="https://www.linkedin.com/in/faizan-azhar-96960a1b3/"
                    twitter="https://twitter.com/mfazhar1"
                    github1="@"
                    github="@"
                    google="@"
                />

                <TeamCard 
                    image={hamza}
                    name="Hamza Qamar"
                    designation="Full Stack Developer"
                    // discription="Meaningful silence is better than meaningless words"
                    facebook="@"
                    linkedin="https://www.linkedin.com/in/hamza-qamar-527aba1b2/"
                    twitter="https://twitter.com/Hamza30421155"
                    github="@"
                    google="@"
                    github1="@"
                />

                <TeamCard 
                    image={abdulla}
                    name="Abdullah"
                    designation="Marketing Manager"
                    // discription="Every exit is an entry somewhere else"
                    facebook="@"
                    linkedin="https://www.linkedin.com/in/abdullah-mudassir-7321a6147/"
                    twitter="@"
                    github="@"
                    google="@"
                    github1="@"
                />
                <TeamCard 
                    image={ibrar}
                    name="Syed Abrar"
                    designation="UI/UX Designer"
                    // discription="Pain is temporary, quitting lasts forever"
                    facebook="@"
                    linkedin="https://www.linkedin.com/mwlite/in/abrar-syed-5a003a155"
                    twitter="@"
                    github="@"
                    google="@"
                    github1="@"
                />
                <TeamCard 
                    image={Shabaz}
                    name="Raja Shahbaz"
                    designation="Marketing Executive"
                    // discription="Only in the darkness can you see the stars"
                    facebook="@"
                    linkedin="https://www.linkedin.com/in/raja-shahbaz-javed-8413b6200"
                    twitter="@"
                    github="@"
                    google="@"
                    github1="@"
                />
                {/* <TeamCard 
                    image={HereisgHassan}
                    name="Hereisg Hassan"
                    designation="Ambassador"
                    discription="Those who are happiest are those who do the most for others"
                    facebook="@"
                    linkedin="@"
                    twitter="@"
                    github="@"
                    google="@"
                    github1="@"
                />
                <TeamCard 
                    image={albin}
                    name="Albin Samuel"
                    designation="Blockchain App Developer"
                    discription="Success is not final; failure is not fatal. It is the courage to continue that counts  "
                    facebook="@"
                    linkedin="@"
                    twitter="@"
                    github="@"
                    google="@"
                    github1="@"
                />
                <TeamCard 
                    image={isaac}
                    name="Isaac Friedman"
                    designation="Community Management"
                    discription="From the errors of others, a wise man corrects his own"
                    facebook="@"
                    linkedin="@"
                    twitter="@"
                    github="@"
                    google="@"
                    github1="@"
                />  */}
                </Grid>
            </Grid>
        </Container>
    </div> 
  );
}

export default Team;
